import { render, staticRenderFns } from "./CardStatistic.vue?vue&type=template&id=0af3a1ac&scoped=true&"
import script from "./CardStatistic.vue?vue&type=script&lang=js&"
export * from "./CardStatistic.vue?vue&type=script&lang=js&"
import style0 from "./CardStatistic.vue?vue&type=style&index=0&id=0af3a1ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af3a1ac",
  null
  
)

export default component.exports